<!---->
<div class="artist-page-container"
     fxLayout="column"
     fxflex="100">

     

     
       <btx-artist-event-list></btx-artist-event-list>


  
</div>
